"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateTimeMySQLHandler", {
    enumerable: true,
    get: function() {
        return DateTimeMySQLHandler;
    }
});
const _datetimegeneralhandler = require("./date-time.general.handler");
let DateTimeMySQLHandler = class DateTimeMySQLHandler extends _datetimegeneralhandler.DateTimeGeneralHandler {
    async parseUserInput(params) {
        const knex = params.options.baseModel.dbDriver;
        const dayjsUtcValue = super.parseDateTime(params).value;
        // first convert the value to utc
        // from UI
        // e.g. 2022-01-01 20:00:00Z -> 2022-01-01 20:00:00
        // from API
        // e.g. 2022-01-01 20:00:00+08:00 -> 2022-01-01 12:00:00
        // if timezone info is not found - considered as utc
        // e.g. 2022-01-01 20:00:00 -> 2022-01-01 20:00:00
        // if timezone info is found
        // e.g. 2022-01-01 20:00:00Z -> 2022-01-01 20:00:00
        // e.g. 2022-01-01 20:00:00+00:00 -> 2022-01-01 20:00:00
        // e.g. 2022-01-01 20:00:00+08:00 -> 2022-01-01 12:00:00
        // then we use CONVERT_TZ to convert that in the db timezone
        const val = dayjsUtcValue ? knex.raw(`CONVERT_TZ(?, '+00:00', @@GLOBAL.time_zone)`, [
            dayjsUtcValue.format('YYYY-MM-DD HH:mm:ss')
        ]) : undefined;
        return {
            value: val
        };
    }
};
